import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import PricingSection from './components/PricingSection';
import ProcessSection from './components/ProcessSection';
import QRCodeSection from './components/QRCodeSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from '../home/components/Footer';

export default function PersonalBrand() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <BenefitsSection />
      <PricingSection />
      <ProcessSection />
      <QRCodeSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
    </div>
  );
}